import { useEffect } from "react";

import { useIsTouchDevice } from "./useIsTouchDevice";

export const useDisableGestures = () => {
  const isTouchDevice = useIsTouchDevice();
  function handleContextMenu(event: MouseEvent) {
    event.preventDefault();
  }

  useEffect(() => {
    if (isTouchDevice) {
      window.addEventListener("contextmenu", handleContextMenu);

      return () => {
        window.removeEventListener("contextmenu", handleContextMenu);
      };
    }
  }, [isTouchDevice]);
};
